import script from "./MobileCollegeSituation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileCollegeSituation.vue?vue&type=script&lang=ts&setup=true"

import "./MobileCollegeSituation.vue?vue&type=style&index=0&id=26e01533&scoped=true&lang=css"
import "./MobileCollegeSituation.vue?vue&type=style&index=1&id=26e01533&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e01533"]])

export default __exports__